import { ResponsibilityRole } from '@/api/generated/schemas';

/**
 * Pevná sada rolí odpovědných osob. Hodnota `role` je string hodnota backendového enumu `ResponsibilityRole`,
 * `key` je suffix lokalizačního klíče (`project.roles.<key>`).
 */
export const RESPONSIBILITY_ROLE_FIELDS = [
  { role: ResponsibilityRole.ProductManager, key: 'productManager' },
  { role: ResponsibilityRole.YieldManager, key: 'yieldManager' },
  { role: ResponsibilityRole.TourLeader, key: 'tourLeader' },
  { role: ResponsibilityRole.TourGuide, key: 'tourGuide' },
] as const;

/** Klíče rolí používané jako názvy polí ve formuláři (`responsiblePersons.<key>`). */
export type ResponsibilityRoleKey = (typeof RESPONSIBILITY_ROLE_FIELDS)[number]['key'];
